var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 17.920000076293945,
    height: 16.923688888549805,
    viewBox: "0 0 17.920000076293945 16.923688888549805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.76076,1.88067C3.7606,2.91943,2.9182,3.76128,1.87944,3.76076C0.840681,3.76024,-0.00087646,2.91755,0.00000156911,1.87879C0.000878925,0.840538,0.843068,-0.000518927,1.88132,0C2.91941,0.000358654,3.76076,0.842257,3.76076,1.88067ZM3.81717,5.15253L0.0564128,5.15253L0.0564128,16.9237L3.81717,16.9237L3.81717,5.15253ZM9.75916,5.15253L6.01721,5.15253L6.01721,16.9237L9.72155,16.9237L9.72155,10.7466C9.72155,7.30556,14.2063,6.98589,14.2063,10.7466L14.2063,16.9237L17.92,16.9237L17.92,9.46799C17.92,3.66703,11.2823,3.88327,9.72155,6.73204L9.75916,5.15253Z",
    fill: "#EFEFEF",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3cce708b1ea3dbacdea7a3646ec9f1c4.svg";
export { ForwardRef as ReactComponent };